"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var FormLabelTheme = function FormLabelTheme(colors) {
  return {
    styleOverrides: {
      root: {
        color: colors.ultramarine,
        '&.Mui-disabled': {
          color: colors.ultramarine,
          transition: 'none'
        },
        '&.Mui-focused': {
          color: colors.ultramarine
        },
        '&.Mui-error': {
          '& .MuiFormControlLabel-label': {
            color: colors.redText
          },
          '& .MuiCheckbox-root:not(.Mui-checked), .MuiRadio-root:not(.Mui-checked)': {
            backgroundColor: colors.redBackground,
            borderColor: colors.redIcon
          },
          '&:hover': {
            '& .MuiCheckbox-root:not(.Mui-checked), .MuiRadio-root:not(.Mui-checked)': {
              backgroundColor: colors.redBackground,
              borderColor: colors.redIcon
            },
            '& .MuiFormControlLabel-label': {
              color: colors.redText
            }
          },
          '& .Mui-checked + .MuiFormControlLabel-label': {
            color: colors.selected
          }
        }
      }
    }
  };
};

var _default = FormLabelTheme;
exports["default"] = _default;